document.addEventListener("DOMContentLoaded", function () {
    if (typeof window.nailChartBtns === 'undefined') {
        window.nailChartBtns = document.querySelectorAll(".nails-size-chart__btn");
    }
    if (typeof window.nailCharts === 'undefined') {
        window.nailCharts = document.querySelectorAll(".nails-length-chart img");
    }

    let linesGrid = document.querySelector(".length-messuring-lines--grid");
    let measuringLines = document.querySelectorAll(".length-measuring-line--grid");

    let classesToRemove = [
        "js__highlighted-length",
        "js__before-highlighted-length",
        "js__before-before-highlighted-length",
        "js__before-before-before-highlighted-length",
    ];

    function removeClassFromLines(classes) {
        measuringLines.forEach(line => {
            classes.forEach(c => line.classList.remove(c));
        });
    }

    function moveMeasuringLines(btn) {
        if (!btn || !linesGrid) return;
        let moveLineTo = btn.getAttribute("data-chart-btn");
        if (moveLineTo) {
            linesGrid.setAttribute('data-using-measuring-line', moveLineTo);
        }
    }

    function toggleChart(btn) {
        if (!btn) return; // safety check
        let btnLine = btn.getAttribute("data-chart-btn");
        if (!btnLine) return;

        removeClassFromLines(classesToRemove);

        let selectedLine = document.querySelector(`.js__${btnLine}`);
        if (!selectedLine) return;

        let currentLine = selectedLine;
        const siblingClasses = [
            "js__before-highlighted-length",
            "js__before-before-highlighted-length",
            "js__before-before-before-highlighted-length"
        ];

        siblingClasses.forEach(className => {
            if (currentLine.previousElementSibling) {
                currentLine = currentLine.previousElementSibling;
                currentLine.classList.add(className);
            }
        });

        selectedLine.classList.add('js__highlighted-length');
    }

    function highLightButtons(btn) {
        if (!btn) return;
        nailChartBtns.forEach(b => {
            b.classList.remove("highlighted__btn");
        });
        btn.classList.add("highlighted__btn");
    }

    if (nailChartBtns.length) {
        nailChartBtns.forEach(function (btn) {
            btn.addEventListener('mouseenter', function () {
                toggleChart(btn);
                moveMeasuringLines(btn);
                // highLightButtons(btn); // Uncomment if needed
            });
        });
    }
});